module.exports = __webpack_public_path__ + "img/icon2.05f9bd55.png";